(() => {
  const MODAL_ID = "PopupModal-krosloCompareTable";
  const TRIGGER_SELECTOR = ".trigger-compare-table";

  const MATERIALS = {
    stainless: {
      label: "Stainless Steel",
      rows: {
        health: "Inert and food-safe",
        durability: "Durable for daily use, but lacks non-stick property",
        practicality:
          "Convenient usage but susceptible to quick damage and burns.",
        heat_retention: "Responds fast to temperature; loses heat quicker",
      },
    },
    aluminium: {
      label: "Aluminium",
      rows: {
        health: "Unsafe for cooking - can leach into food",
        durability: "Soft metal; dents and bends easily",
        practicality: "Lightweight; fast heating; short life",
        heat_retention:
          "Heats fast; cools quickly under heavy loads or when cold ingredients are added.",
      },
    },
    ceramic_steel: {
      label: "Ceramic Steel",
      rows: {
        health: "Safe when intact; coating risk if chipped",
        durability: "Coating can chip over time",
        practicality: "Easy to use but stains and chips possible",
        heat_retention: "Even heating; lower heat hold",
      },
    },
    cast_iron: {
      label: "Cast Iron",
      rows: {
        health: "Generally inert; may transfer iron",
        durability: "Structurally strong but prone to rust",
        practicality: "High maintenance; needs drying & seasoning",
        heat_retention:
          "Excellent heat retention; slow response to temperature changes",
      },
    },
    teflon: {
      label: "Teflon",
      rows: {
        health: "Stable at normal heat; damaged coating risks",
        durability: "Moderate; coating can scratch or flake",
        practicality:
          "Not ideal for high-temperature searing or aggressive metal-utensil use.",
        heat_retention:
          "Heats up fast and responds quickly to changes, but doesn’t hold heat as long as iron.",
      },
    },
    brass: {
      label: "Brass",
      rows: {
        health: "Food-grade possible; some alloys can leach",
        durability: "Structurally tough; surface can tarnish",
        practicality: "Needs polishing; care with acidic foods",
        heat_retention: "Heats quickly; lower retention than iron",
      },
    },
  };

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function setActiveTab(modal, materialKey) {
    const material = MATERIALS[materialKey];
    if (!material) return;

    const tabs = modal.querySelectorAll(".kroslo-compare__tab[data-material]");
    tabs.forEach((btn) => {
      const isActive = btn.dataset.material === materialKey;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    const selectedHeader = modal.querySelector("[data-kroslo-compare-selected]");
    if (selectedHeader) selectedHeader.textContent = material.label;

    const rows = modal.querySelectorAll("[data-kroslo-compare-row]");
    rows.forEach((row) => {
      const rowKey = row.getAttribute("data-kroslo-compare-row");
      const cell = row.querySelector("[data-kroslo-compare-cell]");
      if (!cell) return;
      cell.textContent = material.rows[rowKey] || "";
    });

    modal.setAttribute("data-active-material", materialKey);
  }

  function openCompareModal(openerEl) {
    const modal = getModal();
    if (!modal || typeof modal.show !== "function") return;

    modal.show(openerEl || document.activeElement);

    // Initialize content on open (default Stainless Steel).
    const active =
      modal.getAttribute("data-active-material") ||
      modal.querySelector(".kroslo-compare__tab.is-active")?.dataset.material ||
      "stainless";
    setActiveTab(modal, active);
  }

  // Delegated open handler for theme editor + dynamic content.
  document.addEventListener("click", (e) => {
    const trigger = e.target && e.target.closest
      ? e.target.closest(TRIGGER_SELECTOR)
      : null;
    if (!trigger) return;

    // If the click is on an actual link/button inside, respect default unless it's clearly the compare CTA.
    // We always open the modal, but prevent navigation for anchor tags.
    if (trigger.tagName === "A") e.preventDefault();
    openCompareModal(trigger);
  });

  // Tabs switching inside modal.
  document.addEventListener("click", (e) => {
    const btn =
      e.target && e.target.closest
        ? e.target.closest(".kroslo-compare__tab[data-material]")
        : null;
    if (!btn) return;

    const modal = btn.closest("modal-dialog");
    if (!modal || modal.id !== MODAL_ID) return;

    e.preventDefault();
    setActiveTab(modal, btn.dataset.material);
  });
})();

